import { GrowthBook, GrowthBookPayload } from "@growthbook/growthbook";
import { FeatureFlagsAttributes } from "@/domain/featureFlags";

function createGrowthBookClientProvider(
  payload: GrowthBookPayload,
  attributes: FeatureFlagsAttributes
): GrowthBook {
  const gb = new GrowthBook({
    apiHost: process.env.NEXT_PUBLIC_GROWTHBOOK_API_HOST,
    clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY,
    attributes,
  }).initSync({
    payload,
    streaming: true,
  });

  return gb;
}

export { createGrowthBookClientProvider };
